import React, { Component } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import PropTypes, { oneOfType } from 'prop-types';

class Interstitial extends Component {
  state = { open: false }

  onClose = () => this.setState({ open: false })
  onOpen = () => this.setState({ open: true });
  handleClose = (e) => this.onClose();

  handleGoto = (e) => {
    if (this.props.onGoTo) this.props.onGoTo();
    this.onClose();
  };

  render () {
    return (
      <Modal
        open={ this.state.open }
        onOpen={ this.onOpen }
        onClose={ (e) => this.handleClose(e) }
        basic
        className={ `modal-interstitial ${this.props.class ? this.props.class : ''}` }
        trigger={ this.props.trigger }
      >
        <Modal.Content>
          <div className="modal-wrapper">
            <div className="modal-header">
              {this.props.title &&
              <p className="poppins-semibold"><strong className="poppins-bold">{ this.props.title }</strong><br/> {this.props.subtitle}</p>}
              <button className="modal-close" onClick={ (e) => this.handleClose(e) } />
            </div>
            <div className="modal-main-content">
              {this.props.main_content}
            </div>
            {this.props.phone &&
              <div className="phone-section">
                <img src="/images/phone.svg" alt="phone-icon"></img>
                <p className="poppins-semibold"><strong className="poppins-bold">1-844-817-6468, Option 2.</strong><br/>
                Monday-Friday 8AM-8PM ET.</p>
              </div>}
            {this.props.goToHref &&
            <div className="modal-actions">
              <Button onClick={ this.handleClose }>{this.props.stayBtn}</Button>
              <Button onClick={ this.handleGoto } href={ this.props.goToHref } target="_blank">{this.props.goToText}</Button>
            </div>}

            {/* for enroll modal */}
            {this.props.enrollUrl &&
            <div className="modal-actions">
              <Button onClick={ this.handleGoto } href={ this.props.enrollUrl } target="_blank">{this.props.goToText}</Button>
            </div>}
          </div>
        </Modal.Content>
      </Modal>
    );
  }
};

Interstitial.propTypes = {
  trigger: PropTypes.object,
  main_content: oneOfType([PropTypes.string, PropTypes.object]),
  stayBtn: PropTypes.string,
};

export default Interstitial;
